
import { FC, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link, useNavigate } from "react-router-dom";
import { useLoginHostMutation } from "application/features/hostAuth/authHostApiSlice";
import { selectCurrentToken, setCredentials } from "application/features/hostAuth/authHostSlice";
import { useDispatch, useSelector } from "react-redux";
import InputPsw from "shared/InputPsw/InputPsw";
import { useTranslation } from "react-i18next";

export interface LoginHostProps {
  className?: string;
}

const LoginHost: FC<LoginHostProps> = ({ className = "" }) => {

  const { t, ready } = useTranslation("translation");

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const token = useSelector(selectCurrentToken);

  const [showOtp, setShowOtp] = useState(false);
  const [loginHost, { isLoading }] = useLoginHostMutation()

  useEffect(() => {
    if (token) {
      navigate("/host/")
    }

  }, [token])

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e: any) => {
    e.preventDefault();
    try {
      const loginReponse = await loginHost({ email, password, otp_code: otp }).unwrap()
      if (!loginReponse.error) {
        dispatch(setCredentials({ ...loginReponse }));
        localStorage.setItem('host_token', loginReponse.token)
      }
    } catch (error) {
      setError("Email o password sbagliata")
    }
  }

  const onFormSubmit = async (e: any) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Inserisci email e password")
      return
    }
    try {
      const loginReponse = await loginHost({ email, password }).unwrap()
      if (!loginReponse.error) {
        dispatch(setCredentials({ ...loginReponse }));
        localStorage.setItem('host_token', loginReponse.token)
      }
    }
    catch (error: any) {
      if (error.status === 402) {
        setShowOtp(true);
      } else {
        setError("Dati di accesso non validi")
      }
    }
  }

  if (!ready) return null;

  return (
    <div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
      <Helmet>
        <title>{t("translation:hostLogin.title")} || TRIBYOU</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <div className="max-w-md mx-auto space-y-6 ">
          {/* FORM */}

          {!showOtp ?

            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                {t("translation:hostLogin.heading")}
              </h2>
              <form className="grid grid-cols-1 gap-6" onSubmit={onFormSubmit} method="post">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    {t("translation:hostLogin.form.email")}
                  </span>
                  <Input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="address@example.com"
                    className="mt-1"
                  />
                </label>
                <label className="block">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                  {t("translation:hostLogin.form.password")}
                  </span>
                  <InputPsw
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    className="mt-1"
                  />
                </label>
                <span className="block text-left text-neutral-700 dark:text-neutral-300 cursor-pointer hover:text-primary-6000">
                  <Link to="/reset-password-host">{t("translation:hostLogin.form.forgotPassword")}</Link>
                </span>
                {error && <span className="text-red-500">{error}</span>}
                <ButtonPrimary type="submit" loading={isLoading}>{t("translation:hostLogin.form.loginButton")}</ButtonPrimary>
              </form>

              {/* ==== */}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                <Link to="/become-host">{t("translation:hostLogin.form.createAccount")}</Link>
              </span>
            </>
            :
            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              {t("translation:hostLogin.otpSection.heading")}
              </h2>
              <p className="mt-2 text-neutral-800">
                {t("translation:hostLogin.otpSection.description")}
                <span className="font-semibold"> {email}</span>
              </p>
              <form className="grid grid-cols-1 gap-6" onSubmit={handleLogin} method="post">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                  {t("translation:hostLogin.otpSection.codeLabel")}
                  </span>
                  <Input
                    onChange={(e) => setOtp(e.target.value)}
                    type="text"
                    placeholder="123456"
                    className="mt-1"
                  />
                </label>
                {error && <span className="text-red-500">{error}</span>}
                <ButtonPrimary loading={isLoading} type="submit">{t("translation:hostLogin.otpSection.sendCodeButton")}</ButtonPrimary>
              </form>

              {/* ==== TODO: Missing href to resend the code */}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                {t("translation:hostLogin.otpSection.resendMessage")}{` `}
                  <Link className="text-red-500" to="#">{t("translation:hostLogin.otpSection.resendButton")}</Link>
              </span>
            </>
          }

        </div>
      </div>
    </div>
  );
};

export default LoginHost;
